// The FAQ's address and which page links to which topic. Its own module so Layout (in the main
// bundle, on every page) can render the «¿Dudas?» line without pulling in lib/faq.js and its
// 12 KB of answers, which only the FAQ page, the search box and the ZBE page need.

export const FAQ_PATH = '/preguntas-frecuentes';

// Pages that end with «¿Dudas? Preguntas frecuentes →» (rendered by Layout), and the topic each
// one opens. List pages only: a detail page's questions are the list page's.
export const FAQ_TOPIC_BY_PATH = {
  '/incidencias': 'incidencias',
  '/vecinos': 'vecinos',
  '/torrebus': 'transporte',
  '/renfe': 'transporte',
  '/aparcamiento': 'transporte',
  '/farmacias': 'servicios',
  '/servicios': 'servicios',
  '/residuos': 'servicios',
  '/agenda': 'servicios',
  '/tramites': 'ayuntamiento',
  '/contratacion': 'ayuntamiento',
  '/parcela': 'urbanismo',
  '/urbanismo': 'urbanismo',
  '/transparencia': 'ayuntamiento',
  '/perfil': 'cuenta',
};
